export default {
    photos: [],
    specie: [],
    voyages: [],
    selected: [],
    fullScreen: false,
    carouselTravel: [],
    carouselPort: [],
    carouselRecent: {}
}